import { isFeatureEnabled } from 'owa-feature-flags';
import { getStore } from '../store/store';
import isConsumer from 'owa-session-store/lib/utils/isConsumer';

export default function(): boolean {
    return isFeatureEnabled('cmp-clp') && getStore().userLabels.length > 0 && !isConsumer();
}
